import $http from '$http'
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';

export default {
    methods: {
        getInitData(agentId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                agentId: agentId
            };
            $http.get('api/Agent/GetAgentAccountMoneyNew', params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    let Data = res.data.Data;
                    this.form = Data
                    let num = []
                    for (let i = 0; i < this.form.MofityList.length; i++) {
                        if (this.form.MofityList[i].TotalMoney == -1) {
                            num.push(i)

                        }
                    }
                    this.BookEduListApp = []
                    if (this.form.BookCourseTotalMoney !== -1) {
                        this.BookEduListApp.push({
                            "BookCourseTotalMoney": this.form.BookCourseTotalMoney,
                            "BookCourseUseMoney": this.form.BookCourseUseMoney,
                            "BookCoursePayMoney": this.form.BookCoursePayMoney,
                            "BookCourseArrearMoney": this.form.BookCourseArrearMoney,
                        })
                    }
                    this.HiBList = []
                    if (this.form.LockHiPayUseTotalMoney !== -1) {
                        this.HiBList.push({
                            "LockHiPayUseTotalMoney": this.form.LockHiPayUseTotalMoney,
                            "LockHiPayUseMoney": this.form.LockHiPayUseMoney,
                            "LockHiWithHoldMoney": this.form.LockHiWithHoldMoney,
                            "LockHiPayMoney": this.form.LockHiPayMoney,
                        })
                    }
                    for (let k = 0; k < num.length; k++) {

                        this.form.MofityList.splice(num[k], 1)
                    }
                    // 判断显示
                    if (this.form.Q4List.length > 0) {
                        this.isQ4List = true;
                    } else {
                        this.isQ4List = false;
                    }
                    if (this.form.BookEduList && this.form.BookEduList.length > 0) {
                        this.isBookEduList = true;
                    } else {
                        this.isBookEduList = false;
                    }
                });
            });
        },
        //提交修改
        submit(prams) {
            $http.post('api/Agent/UpdateAgentAccountEx', prams).then(res => {
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });
                    this.dialogVisible = false;
                    this.$emit('reloadList'); // 向上派发 toggle事件
                });
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentAccountManage/components/agentAccountManageDialog/services.js